"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizationRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("typeorm");
const localization_regulatory_fields_country_map_entity_1 = require("../../../../service-lib/src/lib/entities/localization-regulatory-fields-country-map.entity");
const typeorm_2 = require("@nestjs/typeorm");
const user_1 = require("../../../../service-lib/src/lib/entities/user");
const organisation_entity_1 = require("../../../../service-lib/src/lib/entities/organisation.entity");
let LocalizationRepository = class LocalizationRepository {
    constructor(localizationRegulatoryFieldsCountryMap, userRepository, organisationRepository) {
        this.localizationRegulatoryFieldsCountryMap = localizationRegulatoryFieldsCountryMap;
        this.userRepository = userRepository;
        this.organisationRepository = organisationRepository;
    }
    async getUserLocalization(userId) {
        try {
            // Validate userId
            if (!userId) {
                throw new Error('User ID is required.');
            }
            // Fetch the user along with their organization and organization's country
            const user = await this.userRepository.findOne({
                where: { userId: userId },
                relations: ['organisation', 'organisation.country'],
            });
            if (!user) {
                throw new Error('User not found.');
            }
            if (!user.organisation || !user.organisation.country) {
                throw new Error('User organization or country not found.');
            }
            const countryName = user.organisation.country.name;
            const result = await this.localizationRegulatoryFieldsCountryMap
                .createQueryBuilder('map')
                .innerJoinAndSelect('map.country', 'country')
                .innerJoinAndSelect('map.regulatoryField', 'field')
                .where('LOWER(country.name) = LOWER(:countryName)', { countryName })
                .orderBy('country.name', 'ASC')
                .addOrderBy('field.displayOrder', 'ASC')
                .getMany();
            if (result.length === 0) {
                throw new Error('No localization data found for the user\'s country.');
            }
            const { id, name, description, isoCode, locale, currencyCode, currencyDisplayName, currencyFormat, numberFormat, dateFormat, } = result[0].country;
            const fields = result.map(entry => ({
                fieldKey: entry.regulatoryField.fieldKey,
                fieldLabel: entry.fieldLabel || entry.regulatoryField.fieldKey,
                metaData: entry.metaData ?? entry.regulatoryField.metaData,
            }));
            return {
                id,
                name,
                description,
                isoCode,
                locale,
                currencyCode,
                currencyDisplayName,
                currencyFormat,
                numberFormat,
                dateFormat,
                fields,
            };
        }
        catch (error) {
            throw new Error(error.message || 'An unexpected error occurred while fetching user localization.');
        }
    }
    async getOrganizationLocalization(organisationId) {
        try {
            // Validate organizationId
            if (!organisationId) {
                throw new Error('Organization ID is required.');
            }
            // Fetch the organization along with its country
            const organization = await this.organisationRepository.findOne({
                where: { id: organisationId },
                relations: ['country'],
            });
            if (!organization) {
                throw new Error('Organization not found.');
            }
            if (!organization.country) {
                throw new Error('Organization country not found.');
            }
            const countryName = organization.country.name;
            const result = await this.localizationRegulatoryFieldsCountryMap
                .createQueryBuilder('map')
                .innerJoinAndSelect('map.country', 'country')
                .innerJoinAndSelect('map.regulatoryField', 'field')
                .where('LOWER(country.name) = LOWER(:countryName)', { countryName })
                .orderBy('country.name', 'ASC')
                .addOrderBy('field.displayOrder', 'ASC')
                .getMany();
            if (result.length === 0) {
                throw new Error('No localization data found for the organization\'s country.');
            }
            const { id, name, description, isoCode, locale, currencyCode, currencyDisplayName, currencyFormat, numberFormat, dateFormat, } = result[0].country;
            const fields = result.map(entry => ({
                fieldKey: entry.regulatoryField.fieldKey,
                fieldLabel: entry.fieldLabel || entry.regulatoryField.fieldKey,
                metaData: entry.metaData ?? entry.regulatoryField.metaData,
            }));
            return {
                id,
                name,
                description,
                isoCode,
                locale,
                currencyCode,
                currencyDisplayName,
                currencyFormat,
                numberFormat,
                dateFormat,
                fields,
            };
        }
        catch (error) {
            throw new Error(error.message || 'An unexpected error occurred while fetching organization localization.');
        }
    }
};
exports.LocalizationRepository = LocalizationRepository;
exports.LocalizationRepository = LocalizationRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_2.InjectRepository)(localization_regulatory_fields_country_map_entity_1.LocalizationRegulatoryFieldsCountryMap)),
    tslib_1.__param(1, (0, typeorm_2.InjectRepository)(user_1.User)),
    tslib_1.__param(2, (0, typeorm_2.InjectRepository)(organisation_entity_1.Organisation)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_1.Repository !== "undefined" && typeorm_1.Repository) === "function" ? _a : Object, typeof (_b = typeof typeorm_1.Repository !== "undefined" && typeorm_1.Repository) === "function" ? _b : Object, typeof (_c = typeof typeorm_1.Repository !== "undefined" && typeorm_1.Repository) === "function" ? _c : Object])
], LocalizationRepository);
